"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _Main = _interopRequireDefault(require("./Main.render"));
class Main extends _react.Component {
  constructor(props) {
    super(props);
    this.onMenuToggle = () => {
      if (this.state.isMenuOpen) {
        document.body.style.overflow = '';
      } else {
        document.body.style.overflow = 'hidden';
      }
      this.setState(state => ({
        isMenuOpen: !state.isMenuOpen
      }));
    };
    // Debounce used to handle callback being triggered twice when nav icon is clicked
    // as it's detected by click outside as well
    this.onSearchToggle = (0, _debounce.default)(() => this.setState(state => ({
      isSearchShowing: !state.isSearchShowing
    })), 200);
    this.closeSearch = event => {
      if (this.state.isSearchShowing) {
        this.setState({
          isSearchShowing: false
        });
        event.stopPropagation();
      }
    };
    this.showHamburgerMenu = () => {
      const {
        menuItems
      } = this.props;
      return !!(menuItems && menuItems.primary.length > 0);
    };
    this.showSearch = () => {
      const {
        menuItems
      } = this.props;
      return !!(menuItems && menuItems.services &&
      // @ts-ignore
      menuItems.services.filter(x => x.icon === 'SEARCH').length > 0);
    };
    this.state = {
      isMenuOpen: false,
      isSearchShowing: false
    };
  }
  render() {
    const {
      isMenuOpen,
      isSearchShowing
    } = this.state;
    const {
      menuItems,
      fetchError,
      reload
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Main.default, {
      showSearch: this.showSearch(),
      isMenuOpen: isMenuOpen,
      showHamburgerMenu: this.showHamburgerMenu(),
      isSearchShowing: isSearchShowing,
      menuItems: menuItems,
      onMenuToggle: this.onMenuToggle,
      onSearchToggle: this.onSearchToggle,
      closeSearch: this.closeSearch,
      fetchError: fetchError,
      reload: reload,
      ModalComp: this.props.ModalComp
    });
  }
}
var _default = exports.default = Main;